module.exports = __webpack_public_path__ + "static/pielegniarstwo-image-1-122734a91442f591ad97996d859ef641.png";